import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/provider/sima'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class SimaLandApi {

    static async loadProducts({ data = undefined, ...params }) {
        return await fetchService({ url: '/loadproducts', method: 'POST', data, ...params })
    }

    static async loadCategories({ data = undefined, ...params }) {
        return await fetchService({ url: '/loadcategories', method: 'POST', data, ...params })
    }

    static async sendOrder({ data = undefined, ...params }) {
        return await fetchService({ url: '/sendorder', method: 'POST', data, ...params })
    }

}